<div class="official-enrollment-rules-panel">
  <h4 class="panel-title">{{ titleAndDesc.title }}</h4>
  <p>{{ titleAndDesc.description }}</p>
  <min-days-enrolled-input
    *ngIf="panelType == 'minDaysEnrolled'"
  ></min-days-enrolled-input>
  <enrollment-windows-table
    *ngIf="panelType == 'enrollmentWindows'"
  ></enrollment-windows-table>
  <no-shows-input *ngIf="panelType == 'noShows'"></no-shows-input>
</div>
